import { useTab } from '@react-aria/tabs'
import { TabListState } from '@react-stately/tabs'
import cx from 'classnames'
import Styles from './Tab.module.scss'
import { useObjectRef } from 'utils/useObjectRef'
import { Node } from '@react-types/shared'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useWorkspaceColorScheme } from 'hooks/useWorkspaceColorScheme'

interface Props<T> {
  item: Node<T>
  state: TabListState<T>
  className?: string
  withEditorTopColor?: boolean
}

export const Tab = <T,>({ item, state }: Props<T>) => {
  const { key, rendered } = item
  const ref = useObjectRef<HTMLDivElement>()
  const { tabProps } = useTab({ key }, state, ref)
  const isSelected = state.selectedKey === key
  const isDisabled = state.disabledKeys.has(key)
  const { isMobile } = useResponsiveDesign()
  const { isLight } = useWorkspaceColorScheme()

  const getColor = () => {
    if (isMobile && !isSelected) {
      return isLight ? 'var(--dark-40)' : 'var(--light-100)'
    }
  }

  return (
    <div
      {...tabProps}
      ref={ref}
      className={cx(Styles.tab, {
        [Styles.selected]: isSelected,
        [Styles.disabled]: isDisabled,
      })}
    >
      <Text variant="smallList" color={getColor()}>
        {rendered}
      </Text>
    </div>
  )
}
